
import Vue, { PropType } from 'vue';
import Button from '@/components/Button/index.vue';
import { Container, ModalTypes, Wrapper } from './styles';
import { Buttons } from '../../config/types';

export default Vue.extend({
  name: 'ModalAddUser',
  components: {
    Button,
    Container,
    Wrapper,
  },
  props: {
    buttons: {
      type: Array as PropType<Array<Buttons>>,
    },
    icon: {
      type: String,
      default: 'Close',
    },
    description: {
      type: String,
      default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, Lorem ipsum dolor sit amet',
    },
    title: {
      type: String,
      default: 'Lorem ipsum dolor sit amet?',
    },
    type: {
      type: String,
      default: 'primary',
      validator(value: typeof ModalTypes[number]) {
        return ModalTypes.indexOf(value) !== -1;
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isClose: Boolean,
  },
});
